<template>
  <div class="set_b_box" v-if="setBoxBool">
    <div class="set_box">
      <div class="mgx_close_btn close_btn_pos" @click="off">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="set_box_">
        <div class="set_box_left">
          <div class="set_box_left_title">{{ $t('set') }}</div>
          <div class="set_sidebar_list">
            <div class="set_sidebar_item" :class="{ selected: settingActionSet === setEnum.languageSet }" @click="actionSetShow(setEnum.languageSet)">
              <div class="item_icon_wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                </svg>
              </div>
              <div class="item_info">
                <div class="item_title">Language</div>
                <div class="item_desc">{{ currentLanguageName }}</div>
              </div>
            </div>

            <div class="set_sidebar_item" v-if="DeviceManager.instance.state.currentPid != DevicePid.None" :class="{ selected: settingActionSet === setEnum.versionSet }" @click="actionSetShow(setEnum.versionSet)">
              <div class="item_icon_wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
                  <rect x="9" y="9" width="6" height="6" />
                  <line x1="9" y1="1" x2="9" y2="4" />
                  <line x1="15" y1="1" x2="15" y2="4" />
                  <line x1="9" y1="20" x2="9" y2="23" />
                  <line x1="15" y1="20" x2="15" y2="23" />
                  <line x1="20" y1="9" x2="23" y2="9" />
                  <line x1="20" y1="15" x2="23" y2="15" />
                  <line x1="1" y1="9" x2="4" y2="9" />
                  <line x1="1" y1="15" x2="4" y2="15" />
                </svg>
              </div>
              <div class="item_info">
                <div class="item_title">{{ $t('firmware_version') }}</div>
                <div class="item_desc">{{ firmwareVersion || $t('reading') }}</div>
              </div>
            </div>

            <div class="set_sidebar_item" :class="{ selected: settingActionSet === setEnum.aboutSet }" @click="actionSetShow(setEnum.aboutSet)">
              <div class="item_icon_wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="16" x2="12" y2="12" />
                  <line x1="12" y1="8" x2="12.01" y2="8" />
                </svg>
              </div>
              <div class="item_info">
                <div class="item_title">{{ $t('about') }}</div>
                <div class="item_desc">{{ brandHost }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="set_box_right">
          <div class="set_box_right_l" v-if="settingActionSet === setEnum.languageSet">
            <div class="set_box_right_l_ scrollbar_thumb">
              <div class="set_box_right_l_box">
                <div class="set_box_right_l_option" v-for="lang in languagesList" :key="lang.value" :class="{ set_box_right_l_o_active: currentLanguage === lang.value }" @click="changeLang(lang.value)">
                  <div class="set_box_right_l_o_c">
                    <div class="set_box_right_l_o_text">{{ lang.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="set_box_right_v" v-if="settingActionSet === setEnum.versionSet && DeviceManager.instance.state.currentPid != DevicePid.None">
            <div class="set_box_right_v_ scrollbar_thumb">
              <div class="set_box_right_v_box">
                <div class="set_box_right_v_option">
                  <setting_firmware :firmware-version="firmwareVersion" />
                </div>
              </div>
            </div>
          </div>

          <div class="set_box_right_a" v-if="settingActionSet === setEnum.aboutSet">
            <div class="set_box_right_a_t_img logo"></div>
            <div class="set_box_right_a_b_img"></div>
            <div class="set_box_right_a_">
              <div class="set_box_content">
                <div class="set_box_right_a_t">
                  {{ $t(brandTitle) }}
                  {{ $t('device_software') }}
                </div>
                <div class="set_box_right_a_c">
                  {{ `Copyright © ${currentYear} ${brandHost} All right reserved` }}
                </div>
                <div class="set_box_right_a_v" v-if="DeviceManager.instance.state.driverServiceVersion != null">
                  <span v-if="DeviceManager.instance.state.driverServiceVersion != '0'">{{ $t('version') }}: {{ DeviceManager.instance.state.driverServiceVersion }}</span>
                  <span>{{ $t('ui_version') }}: {{ appVersion() }}</span>
                </div>
              </div>

              <div class="restart_service_box" v-if="showRestart">
                <div class="driver_not_response" :class="{ active: showRestartService }" @click="showRestartService = !showRestartService">{{ $t('driver_not_response') }}</div>
                <div class="driver_not_response_tip" v-if="showRestartService">{{ $t('driver_not_response_tip') }}</div>
                <div class="mgx_action_btn primary" v-if="showRestartService" @click="restartService">
                  <div class="icon-wrapper">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
                    </svg>
                  </div>
                  <span>{{ $t('restart_driver') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
enum SetEnum {
  languageSet = 1,
  versionSet = 2,
  aboutSet = 3,
}
import { computed, onMounted, ref, watch } from 'vue'
import { DeviceManager } from '../../service/device'
import { getBrandTitle, getBrandWebsite } from '@/brand/brand'
import { DevicePid } from '@/define/define'
import { DriverService } from '@/service/driver/driver'
import { compare } from 'compare-versions'
import { isElectron } from '@libs/utils/envUtils'
import firmware from '@/upgrade/firmware'
import { appVersion } from '../../service/env'
import { toRefs } from 'vue'
import { isShow42GPair, isShowPairButton } from '../pair_24g/pair_24g.vue'
import { isShowUpgradeFirmware } from '../firmware_upgrade/firmware_upgrade.vue'
import Setting_firmware from './setting_firmware.vue'
import { languages as languagesList, updateLanguage } from '@/languages/i18n'
import i18n from '@/languages/i18n'

const settingActionSet = ref(1)
const setBoxBool = ref(false)
//固件版本
export { setBoxBool, settingActionSet as actionSet }
</script>

<script lang="ts" setup>
const currentLanguage = computed(() => i18n.global.locale)
const currentLanguageName = computed(() => languagesList.find((l) => l.value === currentLanguage.value)?.name || '')

const changeLang = (lang: string) => {
  updateLanguage(lang)
}

const showRestartService = ref(false)
const setEnum = SetEnum
const firmwareVersion = ref<string | null>(null)
const brandTitle = ref<string>('')
const brandHost = ref<string>('')
onMounted(async () => {
  getVersion()
  brandTitle.value = await getBrandTitle()
  brandHost.value = await getBrandWebsite()
})

const { currentPid } = toRefs(DeviceManager.instance.state)
watch(currentPid, () => {
  firmwareVersion.value = null
  if (currentPid.value != 0) {
    getVersion()
  }
})

watch(setBoxBool, (value) => {
  if (value == true && firmwareVersion.value == null) {
    getVersion()
  }
})
watch(isShowUpgradeFirmware, (value) => {
  if (value == true) {
    setBoxBool.value = false
  }
})

const getVersion = () => {
  const device = currentPid.value
  firmware.getFirmwareVersion().then(
    (version: string) => {
      firmwareVersion.value = version
    },
    (err: string) => {
      if (err == 'timeout') {
        if (device != currentPid.value) {
          return
        }
        if (currentPid.value == DevicePid.He6Ultra_24g) {
          isShow42GPair.value = true
          isShowPairButton.value = true
        }
      }
    },
  )
}

const off = () => {
  setBoxBool.value = false
  showRestartService.value = false
}
const actionSetShow = async (o: number) => {
  settingActionSet.value = o
  // if (o == setEnum.versionSet) {
  //   firmwareVersion.value = await DriverService.instance.askDeviceVersion()
  // }
  showRestartService.value = false
}

const currentYear = new Date().getFullYear()
const restartService = () => {
  DriverService.instance.killDriverService()
  off()
}

// 是否显示重连
const showRestart = computed(() => DeviceManager.instance.state.driverServiceVersion != null && compare(DeviceManager.instance.state.driverServiceVersion || '0', '2.1.3', '>=') && isElectron())

watch(
  () => DeviceManager.instance.state.currentPid,
  (value: DevicePid) => {
    if (value == DevicePid.None) {
      setBoxBool.value = false
    }
  },
)
</script>
<style lang="less" scoped>
.set_b_box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: var(--glass-overlay-bg);
  backdrop-filter: var(--glass-overlay-blur);
  -webkit-app-region: no-drag;

  .set_box {
    width: 720px;
    height: 480px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    z-index: 19;
    border-radius: var(--radius-l);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.6);
    /* 核心修复：使用伪元素实现毛玻璃背景 */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(255, 255, 255, 0.4);
      backdrop-filter: blur(40px);
      border-radius: inherit;
      z-index: -1;
      pointer-events: none;
    }

    .close_btn_pos {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 20;
    }

    .set_box_ {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;

      .set_box_left {
        width: 220px;
        height: 100%;
        background: rgba(255, 255, 255, 0.45);
        backdrop-filter: blur(25px);
        border-right: 1px solid rgba(255, 255, 255, 0.3);
        display: flex;
        flex-direction: column;
        flex-shrink: 0;

        .set_box_left_title {
          box-sizing: border-box;
          width: 100%;
          padding: 40px 0 24px 24px;
          color: var(--color-dark);
          font-weight: 800;
          font-size: 22px;
          letter-spacing: -0.5px;
        }

        .set_sidebar_list {
          padding: 0 12px;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .set_sidebar_item {
            padding: 12px 14px;
            cursor: pointer;
            position: relative;
            border-radius: var(--radius-m);
            transition: var(--transition-base);
            display: flex;
            align-items: center;
            gap: 12px;
            border: 1px solid transparent;

            .item_icon_wrapper {
              width: 36px;
              height: 36px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: var(--radius-m);
              background: rgba(0, 0, 0, 0.03);
              flex-shrink: 0;
              color: var(--color-text-hint);
              transition: var(--transition-base);

              svg {
                width: 18px;
                height: 18px;
              }
            }

            .item_info {
              display: flex;
              flex-direction: column;
              min-width: 0;
              flex: 1;

              .item_title {
                font-size: 14px;
                font-weight: 700;
                color: var(--color-dark);
                line-height: 1.2;
              }

              .item_desc {
                font-size: 11px;
                color: var(--color-text-hint);
                margin-top: 2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                opacity: 0.6;
              }
            }

            &:hover {
              background: rgba(255, 255, 255, 0.6);
              transform: translateX(4px);

              .item_icon_wrapper {
                background: rgba(255, 255, 255, 0.8);
                color: var(--color-dark);
              }
            }

            &.selected {
              background: #fff;
              box-shadow: 0 8px 16px rgba(0, 0, 0, 0.04);
              transform: translateX(6px);
              border-color: rgba(255, 255, 255, 0.1);

              .item_icon_wrapper {
                background: rgba(var(--color-brand-2-rgb), 0.1);
                color: var(--brand-color-pure);
              }

              .item_info {
                .item_desc {
                  color: var(--brand-color-pure);
                  opacity: 0.8;
                }
              }

              &::before {
                content: '';
                position: absolute;
                left: -4px;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 18px;
                background: var(--brand-color-pure);
                border-radius: 4px;
              }
            }
          }
        }
      }

      .set_box_right {
        flex: 1;
        height: 100%;
        background-color: var(--color-white);
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        /* 内容容器基础样式 */
        .set_box_right_l,
        .set_box_right_v,
        .set_box_right_a {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 40px;
          display: flex;
          flex-direction: column;
        }

        .scrollbar_thumb {
          flex: 1;
          overflow-y: auto;
          padding-right: 8px;

          &::-webkit-scrollbar {
            width: 4px;
          }

          &::-webkit-scrollbar-thumb {
            border-radius: var(--radius-pill);
            background: rgba(0, 0, 0, 0.1);
          }
        }

        /* 语言网格布局 */
        .set_box_right_l_box {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          padding: 24px;

          .set_box_right_l_option {
            height: 64px;
            border-radius: var(--radius-m);
            border: 1px solid rgba(0, 0, 0, 0.05);
            background: #fff;
            cursor: pointer;
            transition: var(--transition-base);
            display: flex;
            align-items: center;
            justify-content: center;

            .set_box_right_l_o_text {
              font-size: 14px;
              font-weight: 500;
              color: var(--color-dark);
            }

            &:hover {
              transform: translateY(-2px);
              border-color: var(--brand-color-pure);
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
            }

            &.set_box_right_l_o_active {
              background: #fff;
              border-color: var(--brand-color-pure);
              border-width: 1px;
              box-shadow: 0 10px 25px rgba(var(--color-brand-1-rgb), 0.15);

              .set_box_right_l_o_text {
                color: var(--brand-color-pure);
                font-weight: 700;
              }
            }
          }
        }

        /* 固件版本容器 */
        .set_box_right_v {
          .set_box_right_v_ {
            height: 100%;
          }
        }

        /* 关于页面精修 */
        .set_box_right_a {
          justify-content: center;
          align-items: center;
          text-align: center;

          .set_box_right_a_t_img {
            position: absolute;
            width: 100px;
            height: 40px;
            top: 40px;
            right: 40px;
            background-size: contain;
            background-position: right top;
            background-repeat: no-repeat;
            opacity: 0.1;
          }

          .set_box_right_a_b_img {
            width: 200px;
            height: 200px;
            position: absolute;
            bottom: -40px;
            right: -40px;
            background-image: url('@/assets/img/set_b.png');
            background-size: contain;
            background-repeat: no-repeat;
            opacity: 0.04;
            pointer-events: none;
          }

          .set_box_right_a_ {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .set_box_content {
              margin-bottom: 32px;
            }

            .set_box_right_a_t {
              color: var(--color-dark);
              font-size: 26px;
              font-weight: 800;
              margin-bottom: 8px;
            }

            .set_box_right_a_c {
              color: var(--color-text-hint);
              font-size: 13px;
              margin-bottom: 24px;
            }

            .set_box_right_a_v {
              display: flex;
              gap: 12px;
              justify-content: center;

              span {
                background: var(--color-gray-1);
                padding: 6px 16px;
                border-radius: var(--radius-pill);
                font-size: 12px;
                font-weight: 600;
                color: var(--color-text-hint);
                display: flex;
                align-items: center;
                border: 1px solid rgba(0, 0, 0, 0.04);
              }
            }
          }

          .restart_service_box {
            margin-top: 24px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .driver_not_response {
              font-size: 12px;
              color: var(--color-text-hint);
              cursor: pointer;
              transition: var(--transition-base);
              padding-bottom: 2px;
              border-bottom: 1px dashed var(--color-text-hint);

              &:hover,
              &.active {
                color: var(--brand-color-pure);
                border-bottom: 1px solid var(--brand-color-pure);
              }
            }

            .driver_not_response_tip {
              max-width: 300px;
              margin: 16px 0;
              font-size: 12px;
              color: var(--color-text-hint);
              line-height: 1.6;
            }
          }
        }
      }
    }
  }
}
</style>
